import {
  error,
  error100,
  error99,
  error95,
  error90,
  error80,
  error70,
  error60,
  error50,
  error40,
  error30,
  error20,
  error10,
  error0
} from '../../colors.scss';

export default {
  100: error100,
  99: error99,
  95: error95,
  90: error90,
  80: error80,
  70: error70,
  60: error60,
  50: error50,
  40: error40,
  30: error30,
  20: error20,
  10: error10,
  0: error0,
  main: error,
  light: error40,
  dark: error80,
  contrastText: error100
};
